import { AssessmentForMemberRequest } from "./assessment-for-member-request";
import { AssessmentAnswer, wellnessSurveyAnswer } from "./wellnessSurveyQuestionAnswer";

export class AssessmentForMemberUpdateRequest extends AssessmentForMemberRequest
{
    public UserName : string;
    public Status: number;
    public AnswerList : AssessmentAnswer[];
}
